
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { AlertCircle, ChevronLeft } from "lucide-react";

const PaymentCanceled = () => {
  const navigate = useNavigate();
  
  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-50 p-4">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center pb-2">
          <div className="mx-auto mb-4 h-16 w-16 rounded-full bg-amber-100 p-2 flex items-center justify-center">
            <AlertCircle className="h-8 w-8 text-amber-600" />
          </div>
          <CardTitle className="text-2xl font-bold">Payment Canceled</CardTitle>
        </CardHeader>
        <CardContent className="text-center space-y-2 pb-2">
          <p>
            Your payment has been canceled and no charges have been made.
          </p>
          <p className="text-muted-foreground">
            If you encountered any issues during the checkout process, please contact our support team for assistance.
          </p>
        </CardContent>
        <CardFooter className="flex flex-col space-y-2 pt-0">
          <Button 
            onClick={() => navigate('/pricing')} 
            className="w-full"
          >
            <ChevronLeft className="h-4 w-4 mr-1" /> Return to Pricing
          </Button>
          <Button 
            variant="outline" 
            onClick={() => navigate('/dashboard')} 
            className="w-full"
          >
            Go to Dashboard
          </Button>
        </CardFooter>
      </Card>
    </div>
  );
};

export default PaymentCanceled;
